module.exports = __webpack_public_path__ + "img/map_Z2.4.F.06.bfec8554.svg";